// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import membershipToggle from "./membershipToggle";
import archiveYears from "./archiveYears";
import tableOfContents from "./tableOfContents";
import embedWindow from "./embedWindow";


// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();
membershipToggle();
archiveYears();
tableOfContents();
embedWindow();